// // ─────────────────────────────────────────
// //  SHOPIFY WISHLIST  —  wishlist.js
// // ─────────────────────────────────────────

// const WISHLIST_KEY = 'shopify_wishlist';

// function getWishlist() {
//   return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
// }

// function saveWishlist(list) {
//   localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
// }

// // ── Toggle heart on product cards ──
// function toggleWishlist(btn) {
//   const item = {
//     id:        btn.dataset.id,
//     variantId: btn.dataset.variant,
//     title:     btn.dataset.title,
//     img:       btn.dataset.img,
//     price:     btn.dataset.price,
//     url:       btn.dataset.url
//   };

//   let list  = getWishlist();
//   const idx = list.findIndex(p => p.id === item.id);

//   if (idx > -1) {
//     list.splice(idx, 1);
//     btn.classList.remove('wishlisted');
//     btn.innerHTML = '♡';
//     showToast(item.title + ' removed from wishlist');
//   } else {
//     list.push(item);
//     btn.classList.add('wishlisted');
//     btn.innerHTML = '♥';
//     showToast(item.title + ' added to wishlist!');
//   }

// //   saveWishlist(list);
// //   updateWishlistBadge();

// saveWishlist(list);

// // refresh badge everywhere
// setTimeout(updateWishlistBadge, 50);
// }

// // ── Mark already wishlisted items on page load ──
// function markWishlisted() {
//   const list = getWishlist();
//   const ids  = list.map(p => p.id);

//   document.querySelectorAll('.wishlist-heart-btn').forEach(btn => {
//     if (ids.includes(btn.dataset.id)) {
//       btn.classList.add('wishlisted');
//       btn.innerHTML = '♥';
//     }
//   });
// }

// // ── Render wishlist page ──
// function renderWishlistPage() {
//   const grid  = document.getElementById('wishlist-items-grid');
//   const empty = document.getElementById('wishlist-empty-msg');

//   if (!grid) return;

//   const list = getWishlist();

//   if (list.length === 0) {
//     empty.style.display = 'block';
//     return;
//   }

//   grid.innerHTML = '';

//   list.forEach(item => {
//     const price   = parseFloat(item.price).toFixed(2);
//     const imgSrc  = item.img || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';

//     const card    = document.createElement('div');
//     card.className = 'wishlist-card';
//     card.id        = 'wcard-' + item.id;

//     card.innerHTML = `
//       <a href="${item.url}">
//         <img src="${imgSrc}" alt="${item.title}" loading="lazy">
//       </a>
//       <div class="wishlist-card-body">
//         <h4><a href="${item.url}">${item.title}</a></h4>
//         <span class="w-price">$${price}</span>
//         <div class="wishlist-card-actions">
//           <button
//             class="btn-wish-cart"
//             data-variant="${item.variantId}"
//             data-title="${item.title}"
//             onclick="addToCartFromWishlist(this)"
//           >
//             🛒 Add to Cart
//           </button>
//           <button
//             class="btn-wish-remove"
//             onclick="removeFromWishlistPage('${item.id}')"
//           >
//             ✕ Remove
//           </button>
//         </div>
//       </div>
//     `;

//     grid.appendChild(card);
//   });
// }

// // ── Remove from wishlist page ──
// function removeFromWishlistPage(id) {
//   let list = getWishlist();
//   list     = list.filter(p => p.id !== id);
//   saveWishlist(list);

//   const card = document.getElementById('wcard-' + id);
//   if (card) {
//     card.style.transition = 'opacity 0.3s, transform 0.3s';
//     card.style.opacity    = '0';
//     card.style.transform  = 'scale(0.95)';
//     setTimeout(() => {
//       card.remove();
//       if (list.length === 0) {
//         document.getElementById('wishlist-empty-msg').style.display = 'block';
//       }
//     }, 300);
//   }
// }

// // ── Add to cart via Shopify AJAX API ──
// function addToCartFromWishlist(btn) {
//   const variantId = btn.dataset.variant;
//   const title     = btn.dataset.title;

//   btn.disabled    = true;
//   btn.textContent = 'Adding...';

//   fetch('/cart/add.js', {
//     method:  'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body:    JSON.stringify({ id: variantId, quantity: 1 })
//   })
//   .then(res => res.json())
//   .then(() => {
//     btn.textContent = '✓ Added!';
//     showToast(title + ' added to cart!');

//     // Update cart count in header if your theme has one
//     return fetch('/cart.js');
//   })
//   .then(res => res.json())
//   .then(cart => {
//     // Try to update cart count bubble in header
//     const countEls = document.querySelectorAll('[data-cart-count], .cart-count, #cart-count');
//     countEls.forEach(el => el.textContent = cart.item_count);

//     setTimeout(() => {
//       btn.disabled    = false;
//       btn.textContent = '🛒 Add to Cart';
//     }, 2500);
//   })
//   .catch(() => {
//     btn.disabled    = false;
//     btn.textContent = '🛒 Add to Cart';
//     showToast('Something went wrong. Please try again.');
//   });
// }

// // ── Toast notification ──
// function showToast(msg) {
//   let toast = document.getElementById('wish-toast');
//   if (!toast) {
//     toast           = document.createElement('div');
//     toast.id        = 'wish-toast';
//     document.body.appendChild(toast);
//   }
//   toast.textContent = msg;
//   toast.classList.add('show');
//   clearTimeout(toast._timer);
//   toast._timer = setTimeout(() => toast.classList.remove('show'), 3000);
// }

// // ── Attach click listeners to heart buttons ──
// function attachHeartListeners() {
//   document.querySelectorAll('.wishlist-heart-btn').forEach(btn => {
//     // Avoid attaching twice
//     if (btn.dataset.listenerAttached) return;
//     btn.dataset.listenerAttached = 'true';
//     btn.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();
//       toggleWishlist(this);
//     });
//   });
// }

// // function updateWishlistBadge() {
// //   const list  = getWishlist();
// //   const badge = document.getElementById('wishlist-count-badge');
// //   if (!badge) return;
// //   if (list.length > 0) {
// //     badge.textContent   = list.length;
// //     badge.style.display = 'flex';
// //     const link = badge.closest('.header-actions__wishlist');
// //     if (link) link.classList.add('has-items');
// //   } else {
// //     badge.style.display = 'none';
// //     const link = badge.closest('.header-actions__wishlist');
// //     if (link) link.classList.remove('has-items');
// //   }
// // }


// function updateWishlistBadge() {

//   const list = JSON.parse(localStorage.getItem('shopify_wishlist') || '[]');

//   const badges = document.querySelectorAll(
//     '#wishlist-count-badge, .wishlist-count, [data-wishlist-count]'
//   );

//   badges.forEach(badge => {

//     if (list.length > 0) {

//       badge.textContent = list.length;
//       badge.style.display = 'flex';

//     } else {

//       badge.textContent = 0;
//       badge.style.display = 'none';

//     }

//   });

// }

// // ── Init on DOM ready ──
// document.addEventListener('DOMContentLoaded', function () {
//   markWishlisted();
//   attachHeartListeners();
//   renderWishlistPage();
//   updateWishlistBadge();
// });

// // Refresh wishlist badge globally
// document.addEventListener('DOMContentLoaded', updateWishlistBadge);

// // Also update after AJAX navigation
// document.addEventListener('shopify:section:load', updateWishlistBadge);
// document.addEventListener('shopify:section:reorder', updateWishlistBadge);
// document.addEventListener('shopify:section:select', updateWishlistBadge);

// // Safety refresh
// window.addEventListener('load', updateWishlistBadge);


// ─────────────────────────────────────────
//  SHOPIFY WISHLIST — wishlist.js
//  Fixed: cart drawer refresh + badge persistence
// ─────────────────────────────────────────

const WISHLIST_KEY = 'shopify_wishlist';

function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
  } catch (e) {
    return [];
  }
}

function saveWishlist(list) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
}

// ── Badge update ──
function updateWishlistBadge() {
  const count = getWishlist().length;
  document.querySelectorAll(
    '#wishlist-count-badge, .wishlist-count-badge, [data-wishlist-count]'
  ).forEach(function(badge) {
    badge.textContent   = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  });
  document.querySelectorAll('.header-actions__wishlist').forEach(function(link) {
    link.classList.toggle('has-items', count > 0);
  });
}

// ── Watch for badge in DOM and update immediately ──
function watchForBadge() {
  function tryUpdate() {
    const badge = document.getElementById('wishlist-count-badge');
    if (badge) {
      updateWishlistBadge();
      return true;
    }
    return false;
  }

  if (tryUpdate()) return;

  const obs = new MutationObserver(function() {
    if (tryUpdate()) obs.disconnect();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function() { obs.disconnect(); }, 8000);
}

// ── Toggle wishlist heart ──
function toggleWishlist(btn) {
  const item = {
    id:        String(btn.dataset.id),
    variantId: String(btn.dataset.variant),
    title:     btn.dataset.title,
    img:       btn.dataset.img,
    price:     btn.dataset.price,
    url:       btn.dataset.url
  };

  let list  = getWishlist();
  const idx = list.findIndex(function(p) { return String(p.id) === item.id; });

  if (idx > -1) {
    list.splice(idx, 1);
    btn.classList.remove('wishlisted');
    btn.innerHTML = '♡';
    showToast(item.title + ' removed from wishlist');
  } else {
    list.push(item);
    btn.classList.add('wishlisted');
    btn.innerHTML = '♥';
    showToast(item.title + ' added to wishlist!');
  }

  saveWishlist(list);
  updateWishlistBadge();
}

// ── Mark wishlisted hearts on product cards ──
function markWishlisted() {
  const ids = getWishlist().map(function(p) { return String(p.id); });
  document.querySelectorAll('.wishlist-heart-btn').forEach(function(btn) {
    if (ids.includes(String(btn.dataset.id))) {
      btn.classList.add('wishlisted');
      btn.innerHTML = '♥';
    } else {
      btn.classList.remove('wishlisted');
      btn.innerHTML = '♡';
    }
  });
}

// ── Attach click listeners ──
function attachHeartListeners() {
  document.querySelectorAll('.wishlist-heart-btn').forEach(function(btn) {
    if (btn.dataset.listenerAttached) return;
    btn.dataset.listenerAttached = 'true';
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(this);
    });
  });
}

// ── Format price from Shopify (stored in paise) ──
function formatPrice(raw) {
  const n = parseFloat(raw);
  if (isNaN(n)) return raw || '';
  const final = n > 1000 ? n / 100 : n;
  return '₹' + final.toLocaleString('en-IN', { minimumFractionDigits: 2 });
}

// ── Render wishlist page ──
function renderWishlistPage() {
  const grid  = document.getElementById('wishlist-items-grid');
  const empty = document.getElementById('wishlist-empty-msg');
  if (!grid) return;

  const list = getWishlist();
  grid.innerHTML = '';

  if (list.length === 0) {
    if (empty) empty.style.display = 'block';
    return;
  }
  if (empty) empty.style.display = 'none';

  list.forEach(function(item) {
    const imgSrc = item.img ||
      'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';

    const card    = document.createElement('div');
    card.className = 'wishlist-card';
    card.id        = 'wcard-' + item.id;

    card.innerHTML = `
      <a href="${item.url}">
        <img src="${imgSrc}" alt="${item.title}" loading="lazy">
      </a>
      <div class="wishlist-card-body">
        <h4><a href="${item.url}">${item.title}</a></h4>
        <span class="w-price">${formatPrice(item.price)}</span>
        <div class="wishlist-card-actions">
          <button class="btn-wish-cart"
            data-variant="${item.variantId}"
            data-title="${item.title}">
            🛒 Add to Cart
          </button>
          <button class="btn-wish-remove"
            data-id="${item.id}">
            ✕ Remove
          </button>
        </div>
      </div>
    `;

    card.querySelector('.btn-wish-cart').addEventListener('click', function() {
      addToCartFromWishlist(this);
    });
    card.querySelector('.btn-wish-remove').addEventListener('click', function() {
      removeFromWishlistPage(this.dataset.id);
    });

    grid.appendChild(card);
  });
}

// ── Remove from wishlist page ──
function removeFromWishlistPage(id) {
  let list = getWishlist().filter(function(p) { return String(p.id) !== String(id); });
  saveWishlist(list);
  updateWishlistBadge();

  const card = document.getElementById('wcard-' + id);
  if (card) {
    card.style.transition = 'opacity 0.3s, transform 0.3s';
    card.style.opacity    = '0';
    card.style.transform  = 'scale(0.95)';
    setTimeout(function() {
      card.remove();
      if (!document.querySelector('.wishlist-card')) {
        const empty = document.getElementById('wishlist-empty-msg');
        if (empty) empty.style.display = 'block';
      }
    }, 300);
  }
}

// ── Refresh cart drawer HTML from server ──
function refreshCartDrawer() {
  // Horizon theme uses cart-drawer-component with cart-items-component inside
  // We fetch the cart section and replace the inner HTML
  fetch('/?section_id=main-cart-items', {
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
  .then(function(r) { return r.text(); })
  .catch(function() {});

  // Also fire native events that Horizon listens to
  document.dispatchEvent(new CustomEvent('cart:refresh',  { bubbles: true }));
  document.dispatchEvent(new CustomEvent('cart:updated',  { bubbles: true }));

  // Horizon's cart drawer component listens for this specific event
  const cartDrawer = document.querySelector('cart-drawer-component');
  if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
    cartDrawer.renderContents();
  }

  // Force cart-items-component to re-render
  const cartItems = document.querySelector('cart-items-component');
  if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
    cartItems.getSectionsToRender();
  }
}

// ── Update cart bubble count in header ──
function updateCartBubble(itemCount) {
  // Horizon uses cart-bubble component with .cart-bubble__text-count
  document.querySelectorAll(
    '.cart-bubble__text-count, [data-cart-count], .cart-count, #cart-count'
  ).forEach(function(el) {
    el.textContent = itemCount;
  });

  // If count > 0, ensure the cart icon shows the bubble
  const cartIcons = document.querySelectorAll('.header-actions__cart-icon');
  cartIcons.forEach(function(icon) {
    if (itemCount > 0) {
      icon.classList.add('header-actions__cart-icon--has-cart');
    }
  });

  // Dispatch custom event for Horizon cart bubble animation
  document.dispatchEvent(new CustomEvent('cart:item-added', {
    bubbles: true,
    detail: { itemCount: itemCount }
  }));
}

// ── Add to cart via Shopify AJAX ──
function addToCartFromWishlist(btn) {
  const variantId = String(btn.dataset.variant || '').trim();
  const title     = btn.dataset.title || 'Product';

  if (!variantId || variantId === 'undefined' || variantId === 'null' || variantId === '') {
    showToast('Could not add to cart — please visit the product page.');
    return;
  }

  const parsedId = parseInt(variantId, 10);
  if (isNaN(parsedId)) {
    showToast('Invalid product variant. Please visit the product page.');
    return;
  }

  btn.disabled    = true;
  btn.textContent = 'Adding...';

  // Step 1: Add to cart
  fetch('/cart/add.js', {
    method:  'POST',
    headers: {
      'Content-Type':     'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: parsedId, quantity: 1 })
  })
  .then(function(res) {
    if (!res.ok) {
      return res.json().then(function(err) {
        throw new Error(err.description || 'Could not add to cart');
      });
    }
    return res.json();
  })
  .then(function() {
    // Step 2: Get updated cart
    return fetch('/cart.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
  })
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    btn.textContent = '✓ Added!';
    showToast(title + ' added to cart!');

    // Step 3: Update cart bubble number
    updateCartBubble(cart.item_count);

    // Step 4: Refresh cart drawer contents
    refreshCartDrawer();

    // Step 5: Also fetch and update cart sections that Horizon uses
    const sections = ['cart-drawer'];
    fetch('/cart?sections=' + sections.join(','), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(r) { return r.json(); })
    .then(function(sectionsData) {
      // Update cart drawer HTML if Horizon exposes the section
      Object.keys(sectionsData).forEach(function(sectionId) {
        const sectionHTML = sectionsData[sectionId];
        const parser      = new DOMParser();
        const doc         = parser.parseFromString(sectionHTML, 'text/html');

        // Try to find and replace cart drawer inner content
        const newDrawer = doc.querySelector('.cart-drawer__inner, cart-items-component');
        const oldDrawer = document.querySelector('.cart-drawer__inner, cart-items-component');
        if (newDrawer && oldDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
        }
      });
    })
    .catch(function() {
      // Section fetch failed — that's ok, bubble was already updated
    });

    setTimeout(function() {
      btn.disabled    = false;
      btn.textContent = '🛒 Add to Cart';
    }, 2500);
  })
  .catch(function(err) {
    console.error('Wishlist add to cart error:', err);
    btn.disabled    = false;
    btn.textContent = '🛒 Add to Cart';
    showToast(err.message || 'Something went wrong. Try visiting the product page.');
  });
}

// ── Toast ──
function showToast(msg) {
  let toast = document.getElementById('wish-toast');
  if (!toast) {
    toast    = document.createElement('div');
    toast.id = 'wish-toast';
    toast.style.cssText = [
      'position:fixed', 'bottom:30px', 'right:30px',
      'background:#1a1a2e', 'color:#fff',
      'padding:13px 22px', 'border-radius:10px',
      'font-size:14px', 'font-weight:600',
      'z-index:99999', 'opacity:0',
      'transform:translateY(20px)',
      'transition:opacity 0.3s ease,transform 0.3s ease',
      'pointer-events:none'
    ].join(';');
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.getBoundingClientRect();
  toast.style.opacity   = '1';
  toast.style.transform = 'translateY(0)';
  clearTimeout(toast._timer);
  toast._timer = setTimeout(function() {
    toast.style.opacity   = '0';
    toast.style.transform = 'translateY(20px)';
  }, 3000);
}

// ─────────────────────────────────────────
//  INIT — runs in correct order
// ─────────────────────────────────────────

// 1. Watch for badge element immediately (before DOM ready)
watchForBadge();

// 2. Full init on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  updateWishlistBadge();
  markWishlisted();
  attachHeartListeners();
  renderWishlistPage();
});

// 3. Re-run after Shopify section loads
document.addEventListener('shopify:section:load', function() {
  updateWishlistBadge();
  markWishlisted();
  attachHeartListeners();
});

// 4. Safety net after full page load
window.addEventListener('load', function() {
  updateWishlistBadge();
  markWishlisted();
  attachHeartListeners();
});